import React, { useMemo } from 'react';
import { Section, SkeletonItem } from '@atlaskit/side-navigation';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { getSystemNavigationPaths } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/get-navigation-path/system/index.tsx';
import { matchUrlPathname } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import { useFeatures } from '../../../controllers/features/index.tsx';
import messages from './messages.tsx';

/**
 *  Returns Menu navigation respecting the current user permissions
 *  When updating this file, make sure to also update the following files if necessary:
 * - src/packages/navigation-apps/sidebar/common/src/controllers/use-navigation-path/system
 */
export const SharedSection = (): React.JSX.Element => {
	const { data: features } = useFeatures();
	const { formatMessage } = useIntl();

	const navigationPath = useMemo(() => getSystemNavigationPaths(), []);

	if (features == null) return <SkeletonItem />;

	return (
		<Section title={formatMessage(messages.sharedItems)}>
			{features.hasManageFilters && (
				<MenuItem
					analytics={{
						itemId: 'manage-filters',
					}}
					href={navigationPath.sharedSectionManageFilters}
					selectedOn={matchUrlPathname()}
				>
					{formatMessage(messages.filters)}
				</MenuItem>
			)}
			{features.hasManageDashboards && (
				<MenuItem
					analytics={{ itemId: 'manage-dashboards' }}
					href={navigationPath.sharedManageDashboards}
					selectedOn={matchUrlPathname()}
				>
					{formatMessage(messages.dashboards)}
				</MenuItem>
			)}
		</Section>
	);
};
